function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable max-lines */
import React from 'react';
import { createRoutesFromElements, Route } from 'react-router';

import { App } from "./App/App";
import LibraryRoot from "./Library/Library";
import { LibraryMap } from "./Library/LibraryMap";
import { LibraryCards } from "./Library/LibraryCards";
import { LibraryTable } from "./Library/LibraryTable";
import { PreserveSettings, EntityTypesList, Settings } from "./Settings";
import { EditTemplate } from "./Templates/EditTemplate";
import NewTemplate from "./Templates/NewTemplate";
import { Login } from "./Users/Login";
import { Users, usersLoader, userAction } from "./V2/Routes/Settings/Users/Users";
import { Collection, collectionLoader } from "./V2/Routes/Settings/Collection/Collection";
import ViewerRoute from "./Viewer/ViewerRoute";

import {
  TranslationsList,
  translationsListLoader } from "./V2/Routes/Settings/Translations/TranslationsList";

import {
  EditTranslations,
  editTranslationsLoader,
  editTranslationsAction } from "./V2/Routes/Settings/Translations/EditTranslations";

import { Dashboard, dashboardLoader } from "./V2/Routes/Settings/Dashboard/Dashboard";

import {
  EditThesaurus,
  thesauriLoader,
  ThesauriList,
  editThesaurusLoader } from "./V2/Routes/Settings/Thesauri";


import { MenuConfig, menuConfigloader } from "./V2/Routes/Settings/MenuConfig/MenuConfig";
import {
  RelationshipTypes,
  relationshipTypesLoader } from "./V2/Routes/Settings/RelationshipTypes/RelationshipTypes";

import { LanguagesList, languagesListLoader } from "./V2/Routes/Settings/Languages/LanguagesList";
import { Account, accountLoader } from "./V2/Routes/Settings/Account/Account";
import { IXdashboardLoader, IXDashboard } from "./V2/Routes/Settings/IX/IXDashboard";
import { IXSuggestions, IXSuggestionsLoader } from "./V2/Routes/Settings/IX/IXSuggestions";
import { PageEditor, pageEditorLoader, PagesList, pagesListLoader } from "./V2/Routes/Settings/Pages";
import { customisationLoader, Customisation } from "./V2/Routes/Settings/Customization/Customization";
import { ActivityLog, activityLogLoader } from "./V2/Routes/Settings/ActivityLog";
import { CustomUploads, customUploadsLoader } from "./V2/Routes/Settings/CustomUploads/CustomUploads";
import { FiltersTable, filtersLoader } from "./V2/Routes/Settings/Filters";
import { RouteErrorBoundary, GeneralError } from "./V2/Components/ErrorHandling";
import {
  ParagraphExtractorLoader,
  PXEntityLoader,
  PXParagraphLoader } from "./V2/Routes/Settings/ParagraphExtraction/Loaders";

import { ParagraphExtractorDashboard } from "./V2/Routes/Settings/ParagraphExtraction/ParagraphExtraction";
import { PXEntityDashboard } from "./V2/Routes/Settings/ParagraphExtraction/PXEntities";
import { PXParagraphDashboard } from "./V2/Routes/Settings/ParagraphExtraction/PXParagraphs";
import {
  loggedInUsersRoute,
  adminsOnlyRoute,
  privateRoute,
  ProtectedRoute } from "./ProtectedRoute";

import { getIndexElement } from "./getIndexElement";
import { PageView } from "./Pages/PageView";
import ResetPassword from "./Users/ResetPassword";
import ConnectedUnlockAccount from "./Users/UnlockAccount";
import OneUpReview from "./Review/OneUpReview";
import { NewRelMigrationDashboard } from "./Settings/components/relV2MigrationDashboard";

const getRoutesLayout = (
settings,
indexElement,
headers,
defaultToLibrary) => {var _settings$features;return (/*#__PURE__*/

    _jsx(Route, { errorElement: /*#__PURE__*/_jsx(RouteErrorBoundary, {}) }, void 0, /*#__PURE__*/
    React.createElement(Route, _extends({
      index: true,
      element: indexElement },
    defaultToLibrary ? { handle: { library: true } } : {})
    ), /*#__PURE__*/
    _jsx(Route, { path: "login", element: /*#__PURE__*/_jsx(Login, {}) }), /*#__PURE__*/
    _jsx(Route, { path: "library/*", element: privateRoute(/*#__PURE__*/_jsx(LibraryRoot, {}), settings) }, void 0, /*#__PURE__*/
    _jsx(Route, { index: true, element: privateRoute(/*#__PURE__*/_jsx(LibraryCards, {}), settings), handle: { library: true } }), /*#__PURE__*/
    _jsx(Route, {
      path: "map",
      element: privateRoute(/*#__PURE__*/_jsx(LibraryMap, {}), settings),
      handle: { library: true } }
    ), /*#__PURE__*/
    _jsx(Route, {
      path: "table",
      element: privateRoute(/*#__PURE__*/_jsx(LibraryTable, {}), settings),
      handle: { library: true } }
    )
    ), /*#__PURE__*/
    _jsx(Route, { path: "document/:sharedId", element: privateRoute(/*#__PURE__*/_jsx(ViewerRoute, {}), settings) }, void 0, /*#__PURE__*/
    _jsx(Route, { path: "*", element: privateRoute(/*#__PURE__*/_jsx(ViewerRoute, {}), settings) })
    ), /*#__PURE__*/
    _jsx(Route, { path: "entity/:sharedId", element: privateRoute(/*#__PURE__*/_jsx(ViewerRoute, {}), settings) }, void 0, /*#__PURE__*/
    _jsx(Route, { path: "*", element: privateRoute(/*#__PURE__*/_jsx(ViewerRoute, {}), settings) })
    ), /*#__PURE__*/
    _jsx(Route, { path: "entity/:sharedId/:tabView", element: privateRoute(/*#__PURE__*/_jsx(ViewerRoute, {}), settings) }), /*#__PURE__*/
    _jsx(Route, { path: "error/:errorCode", element: /*#__PURE__*/_jsx(GeneralError, {}) }), /*#__PURE__*/
    _jsx(Route, { path: "404", element: /*#__PURE__*/_jsx(GeneralError, {}) }), /*#__PURE__*/
    _jsx(Route, { path: "page/:sharedId", element: /*#__PURE__*/_jsx(PageView, {}) }), /*#__PURE__*/
    _jsx(Route, { path: "page/:sharedId/:slug", element: /*#__PURE__*/_jsx(PageView, {}) }), /*#__PURE__*/
    _jsx(Route, { path: "setpassword/:key", element: /*#__PURE__*/_jsx(ResetPassword, {}) }), /*#__PURE__*/
    _jsx(Route, { path: "unlockaccount/:username/:code", element: /*#__PURE__*/_jsx(ConnectedUnlockAccount, {}) }), /*#__PURE__*/
    _jsx(Route, { path: "review", element: adminsOnlyRoute(/*#__PURE__*/_jsx(OneUpReview, {})) }), /*#__PURE__*/
    _jsx(Route, { path: "settings", element: loggedInUsersRoute(/*#__PURE__*/_jsx(Settings, {})) }, void 0, /*#__PURE__*/
    _jsx(Route, { path: "account", element: /*#__PURE__*/_jsx(Account, {}), loader: accountLoader(headers) }), /*#__PURE__*/
    _jsx(Route, {
      path: "dashboard",
      element: adminsOnlyRoute(/*#__PURE__*/_jsx(Dashboard, {})),
      loader: dashboardLoader(headers) }
    ), /*#__PURE__*/
    _jsx(Route, {
      path: "navlinks",
      element: adminsOnlyRoute(/*#__PURE__*/_jsx(MenuConfig, {})),
      loader: menuConfigloader(headers) }
    ), /*#__PURE__*/
    _jsx(Route, {
      path: "collection",
      element: adminsOnlyRoute(/*#__PURE__*/_jsx(Collection, {})),
      loader: collectionLoader(headers) }
    ), /*#__PURE__*/
    _jsx(Route, {
      path: "users",
      element: adminsOnlyRoute(/*#__PURE__*/_jsx(Users, {})),
      loader: usersLoader(headers),
      action: userAction() }
    ), /*#__PURE__*/
    _jsx(Route, { path: "preserve", element: adminsOnlyRoute(/*#__PURE__*/_jsx(PreserveSettings, {})) }), /*#__PURE__*/
    _jsx(Route, { path: "pages" }, void 0, /*#__PURE__*/
    _jsx(Route, { index: true, element: adminsOnlyRoute(/*#__PURE__*/_jsx(PagesList, {})), loader: pagesListLoader(headers) }), /*#__PURE__*/
    _jsx(Route, {
      path: "page/:sharedId?",
      element: adminsOnlyRoute(/*#__PURE__*/_jsx(PageEditor, {})),
      loader: pageEditorLoader(headers) }
    )
    ), /*#__PURE__*/
    _jsx(Route, { path: "templates" }, void 0, /*#__PURE__*/
    _jsx(Route, { index: true, element: adminsOnlyRoute(/*#__PURE__*/_jsx(EntityTypesList, {})) }), /*#__PURE__*/
    _jsx(Route, { path: "new", element: adminsOnlyRoute(/*#__PURE__*/_jsx(NewTemplate, {})) }), /*#__PURE__*/
    _jsx(Route, { path: "edit/:templateId", element: adminsOnlyRoute(/*#__PURE__*/_jsx(EditTemplate, {})) })
    ), /*#__PURE__*/
    _jsx(Route, { path: "metadata_extraction" }, void 0, /*#__PURE__*/
    _jsx(Route, {
      index: true,
      element: /*#__PURE__*/
      _jsx(ProtectedRoute, { allowedRoles: ['admin', 'editor'] }, void 0, /*#__PURE__*/
      _jsx(IXDashboard, {})
      ),

      loader: IXdashboardLoader(headers) }
    ), /*#__PURE__*/
    _jsx(Route, {
      path: "suggestions/:extractorId",
      loader: IXSuggestionsLoader(headers),
      element: /*#__PURE__*/
      _jsx(ProtectedRoute, { allowedRoles: ['admin', 'editor'] }, void 0, /*#__PURE__*/
      _jsx(IXSuggestions, {})
      ) }

    )
    ), /*#__PURE__*/
    _jsx(Route, { path: "paragraph-extraction" }, void 0, /*#__PURE__*/
    _jsx(Route, {
      loader: ParagraphExtractorLoader(headers),
      index: true,
      element: adminsOnlyRoute(/*#__PURE__*/_jsx(ParagraphExtractorDashboard, {})) }
    ), /*#__PURE__*/
    _jsx(Route, {
      loader: PXEntityLoader(headers),
      path: ":extractorId/entities",
      element: adminsOnlyRoute(/*#__PURE__*/_jsx(PXEntityDashboard, {})) }
    ), /*#__PURE__*/
    _jsx(Route, {
      loader: PXParagraphLoader(headers),
      path: ":extractorId/entities/:entityId/paragraphs",
      element: adminsOnlyRoute(/*#__PURE__*/_jsx(PXParagraphDashboard, {})) }
    )
    ), /*#__PURE__*/
    _jsx(Route, { path: "relationship-types" }, void 0, /*#__PURE__*/
    _jsx(Route, {
      index: true,
      element: adminsOnlyRoute(/*#__PURE__*/_jsx(RelationshipTypes, {})),
      loader: relationshipTypesLoader(headers) }
    )
    ), /*#__PURE__*/

    _jsx(Route, { path: "thesauri" }, void 0, /*#__PURE__*/
    _jsx(Route, { index: true, element: adminsOnlyRoute(/*#__PURE__*/_jsx(ThesauriList, {})), loader: thesauriLoader(headers) }), /*#__PURE__*/
    _jsx(Route, { path: "new", element: adminsOnlyRoute(/*#__PURE__*/_jsx(EditThesaurus, {})) }), /*#__PURE__*/
    _jsx(Route, {
      path: "edit/:_id",
      element: adminsOnlyRoute(/*#__PURE__*/_jsx(EditThesaurus, {})),
      loader: editThesaurusLoader(headers) }
    )
    ), /*#__PURE__*/
    _jsx(Route, {
      path: "languages",
      element: adminsOnlyRoute(/*#__PURE__*/_jsx(LanguagesList, {})),
      loader: languagesListLoader(headers) }
    ), /*#__PURE__*/
    _jsx(Route, { path: "translations" }, void 0, /*#__PURE__*/
    _jsx(Route, {
      index: true,
      element: adminsOnlyRoute(/*#__PURE__*/_jsx(TranslationsList, {})),
      loader: translationsListLoader(headers) }
    ), /*#__PURE__*/
    _jsx(Route, {
      path: "edit/:context",
      element: adminsOnlyRoute(/*#__PURE__*/_jsx(EditTranslations, {})),
      loader: editTranslationsLoader(headers),
      action: editTranslationsAction() }
    )
    ), /*#__PURE__*/
    _jsx(Route, {
      path: "filters",
      element: adminsOnlyRoute(/*#__PURE__*/_jsx(FiltersTable, {})),
      loader: filtersLoader(headers) }
    ), /*#__PURE__*/
    _jsx(Route, {
      path: "customisation",
      element: adminsOnlyRoute(/*#__PURE__*/_jsx(Customisation, {})),
      loader: customisationLoader(headers) }
    ), /*#__PURE__*/
    _jsx(Route, {
      path: "activitylog",
      element: adminsOnlyRoute(/*#__PURE__*/_jsx(ActivityLog, {})),
      loader: activityLogLoader(headers, { settings }) }
    ), /*#__PURE__*/
    _jsx(Route, {
      path: "custom-uploads",
      element: adminsOnlyRoute(/*#__PURE__*/_jsx(CustomUploads, {})),
      loader: customUploadsLoader(headers) }
    ), /*#__PURE__*/
    _jsx(Route, {
      path: "newrelmigration",
      element:
      settings !== null && settings !== void 0 && (_settings$features = settings.features) !== null && _settings$features !== void 0 && _settings$features.newRelationships ? /*#__PURE__*/_jsx(NewRelMigrationDashboard, {}) : /*#__PURE__*/_jsx(GeneralError, {}) }

    )
    )
    ));};


const languageLayout = (langKey, layout) => /*#__PURE__*/
_jsx(Route, { path: langKey }, langKey,
layout, /*#__PURE__*/
_jsx(Route, { path: "*", element: /*#__PURE__*/_jsx(GeneralError, {}) })
);


const getRoutes = (
settings,
userId,
headers) =>
{var _settings$languages;
  const { element, parameters, defaultToLibrary } = getIndexElement(settings, userId);
  const layout = getRoutesLayout(settings, element, headers, defaultToLibrary);
  const languageKeys = (settings === null || settings === void 0 ? void 0 : (_settings$languages = settings.languages) === null || _settings$languages === void 0 ? void 0 : _settings$languages.map((lang) => lang.key)) || [];
  return createRoutesFromElements(/*#__PURE__*/
    _jsx(Route, {
      path: "/",
      element: /*#__PURE__*/_jsx(App, { customParams: parameters }),
      errorElement: /*#__PURE__*/_jsx(RouteErrorBoundary, {}) }, void 0,

    layout,
    languageKeys.map((langKey) => languageLayout(langKey, layout)), /*#__PURE__*/
    _jsx(Route, { path: "*", element: /*#__PURE__*/_jsx(GeneralError, {}) })
    )
  );
};

export { getRoutes };